import { Suspense } from 'react';
import { LoadingScreen } from 'src/components/loading-screen';
import GuestLayout from 'src/layouts/guest/layout';
import TrangTraCuu from 'src/pages/guest/tra-cuu-an-pham';
import TrangChiTiet from 'src/pages/guest/chi-tiet-an-pham';
import TrangGioSach from 'src/pages/guest/gio-sach';
import TrangDangKy from 'src/pages/guest/dang-ky-the';
import TrangXacNhan from 'src/pages/guest/xac-nhan-dang-ky-muon';

export const guestRoutes = [
  {
    path: 'tra-cuu',
    element: (
      <GuestLayout>
        <Suspense fallback={<LoadingScreen />}>
          <TrangTraCuu />
        </Suspense>
      </GuestLayout>
    ),
    index: true,
  },
  {
    path: 'tra-cuu/:slug',
    element: (
      <GuestLayout>
        <Suspense fallback={<LoadingScreen />}>
          <TrangChiTiet />
        </Suspense>
      </GuestLayout>
    ),
  },
  {
    path: 'gio-sach',
    element: (
      <GuestLayout>
        <Suspense fallback={<LoadingScreen />}>
          <TrangGioSach />
        </Suspense>
      </GuestLayout>
    ),
  },
  {
    path: 'dang-ky-the',
    element: (
      <GuestLayout>
        <Suspense fallback={<LoadingScreen />}>
          <TrangDangKy />
        </Suspense>
      </GuestLayout>
    ),
  },
  {
    path: 'xac-nhan-dang-ky-muon/:token',
    element: (
      <GuestLayout>
        <Suspense fallback={<LoadingScreen />}>
          <TrangXacNhan />
        </Suspense>
      </GuestLayout>
    ),
  },
];
